import { createHttpClient, getStoredSession } from "./client";

/**
 * 游戏化进度接口封装。
 * 用于同步抽卡、任务、等级等前端状态。
 */
export function createGameApi(baseUrl) {
  const http = createHttpClient(baseUrl);

  return {
    /**
     * 拉取抽卡角色池。角色画像由后端生成并返回服务器图片地址。
     */
    fetchCharacters() {
      return http.get("/quark/auth/wechat/game/characters");
    },
    fetchUi2Overview() {
      const wxLoginToken = getStoredSession();
      return http.get("/quark/auth/wechat/game/ui2/overview", {
        params: wxLoginToken ? { wxLoginToken } : undefined
      });
    },
    fetchUi2Pool() {
      return http.get("/quark/auth/wechat/game/ui2/pool");
    },
    drawGachaUi2(times) {
      const wxLoginToken = getStoredSession();
      return http.post("/quark/auth/wechat/game/ui2/draw", { times }, {
        params: { wxLoginToken, times }
      });
    },
    fetchCollection() {
      const wxLoginToken = getStoredSession();
      return http.get("/quark/auth/wechat/game/collection", {
        params: wxLoginToken ? { wxLoginToken } : undefined
      });
    },
    createCharacter(payload) {
      return http.post("/quark/auth/wechat/game/characters", payload);
    },
    updateCharacter(id, payload) {
      return http.put(`/quark/auth/wechat/game/characters/${id}`, payload);
    },
    deleteCharacter(id) {
      return http.delete(`/quark/auth/wechat/game/characters/${id}`);
    },
    /**
     * 拉取当前会话对应的云端进度。
     */
    fetchProgress() {
      const wxLoginToken = getStoredSession();
      return http.get("/quark/auth/wechat/game/queryProgress", {
        params: wxLoginToken ? { wxLoginToken } : undefined
      });
    },
    checkIn() {
      const wxLoginToken = getStoredSession();
      return http.post("/quark/auth/wechat/game/checkIn", { wxLoginToken }, {
        params: wxLoginToken ? { wxLoginToken } : undefined
      });
    },
    finishCraft(payload) {
      const wxLoginToken = getStoredSession();
      return http.post("/quark/auth/wechat/game/craft/finish", { ...payload, wxLoginToken }, {
        params: wxLoginToken ? { wxLoginToken } : undefined
      });
    },
    claimMission(key) {
      const wxLoginToken = getStoredSession();
      return http.post("/quark/auth/wechat/game/mission/claim", { key, wxLoginToken }, {
        params: wxLoginToken ? { wxLoginToken } : undefined
      });
    },
    drawGacha(times) {
      const wxLoginToken = getStoredSession();
      return http.post("/quark/auth/wechat/game/draw", { times, wxLoginToken }, {
        params: wxLoginToken ? { wxLoginToken } : undefined
      });
    },
    /**
     * 保存当前会话对应的云端进度。
     */
    saveProgress(payload) {
      const wxLoginToken = getStoredSession();
      return http.post("/quark/auth/wechat/game/saveProgress", {
        ...payload,
        wxLoginToken
      }, {
        params: wxLoginToken ? { wxLoginToken } : undefined
      });
    }
  };
}
